module.exports = function session({ cookieName = 'session_id', maxAge = 86400000 } = {}) {
    const crypto = require('crypto');
    const store = new Map();
    return (req, res, next) => {
        let sessionId = req.cookies && req.cookies[cookieName];
        if (!sessionId || !store.has(sessionId)) {
            sessionId = crypto.randomUUID();
            store.set(sessionId, { _createdAt: Date.now() });
            if (res.cookie) {
                res.cookie(cookieName, sessionId, { maxAge: maxAge / 1000, httpOnly: true });
            }
        }
        req.session = store.get(sessionId);
        next();
    };
};
